// extracted by mini-css-extract-plugin
export default {"logo":"recommendationshJmoKw","placeholder":"recommendationsK7kDCi","logo__image":"recommendationsnjO7-j"};